import React, { useEffect, useState } from "react";

interface TypewriterHeaderProps {
	lines: string[];
	typeSpeed?: number;
	eraseSpeed?: number;
	holdMs?: number;
	className?: string;
}

const TypewriterHeader: React.FC<TypewriterHeaderProps> = ({
	lines,
	typeSpeed = 70,
	eraseSpeed = 35,
	holdMs = 1500,
	className = "",
}) => {
	const [lineIndex, setLineIndex] = useState(0);
	const [text, setText] = useState("");
	const [phase, setPhase] = useState<"typing" | "holding" | "erasing">(
		"typing",
	);

	useEffect(() => {
		if (!lines || lines.length === 0) return;
		const current = lines[lineIndex] ?? "";

		let timeout: NodeJS.Timeout;

		if (phase === "typing") {
			if (text.length < current.length) {
				timeout = setTimeout(
					() => setText(current.slice(0, text.length + 1)),
					typeSpeed,
				);
			} else {
				timeout = setTimeout(() => setPhase("holding"), holdMs);
			}
		} else if (phase === "holding") {
			timeout = setTimeout(() => setPhase("erasing"), 0);
		} else if (phase === "erasing") {
			if (text.length > 0) {
				timeout = setTimeout(
					() => setText(current.slice(0, text.length - 1)),
					eraseSpeed,
				);
			} else {
				setLineIndex((prev) => (prev + 1) % lines.length);
				setPhase("typing");
			}
		}

		return () => clearTimeout(timeout);
	}, [text, phase, lineIndex, lines, typeSpeed, eraseSpeed, holdMs]);

	return (
		<h1
			className={`typewriter-line text-center font-medium ${className}`}
			aria-live="polite"
		>
			{text}
			<span className="typewriter-caret">|</span>
		</h1>
	);
};

export default TypewriterHeader;
